import { CSSProperties, FC } from 'react';
import { IconButton } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { EMPTY_FUNCTION } from '@uplift/constants';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 56,
    height: 56,
    fill: '#57807D',
    cursor: 'pointer',
    padding: 0,
    '&:hover': {
      backgroundColor: '#57807D',
      boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)',
      fill: 'white',
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
});

export type CircleIconButtonType = {
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
};

export const CircleIconButton: FC<CircleIconButtonType> = ({ children, className, style, onClick = EMPTY_FUNCTION }) => {
  const { classes } = useStyles();

  return (
    <IconButton
      classes={{
        root: `${classes.root} ${className}`
      }}
      aria-label="edit"
      component="span"
      style={style}
      onClick={onClick}
    >
      {children}
    </IconButton>
  );
};
